// extracted by mini-css-extract-plugin
export default {"commentsOwner":"GameComments_commentsOwner__DtqWE","head":"GameComments_head__qScFH","table":"GameComments_table__L-37C","freeText":"GameComments_freeText__iKMeU"};